// Meta Pixel tracking utilities

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return

  // Check if already initialized
  if (window.fbq) return

  // Initialize fbq function
  const fbq: any = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments)
  }

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  // Create and insert the script element safely
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Use head or body - don't rely on existing script tags
  const target = document.head || document.body
  if (target) {
    target.appendChild(script)
  }

  window.fbq('init', '2408288229622449')
  window.fbq('track', 'PageView')
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Sleep & Serenity Libro Digital',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}

export const trackInitiateCheckout = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Sleep & Serenity Libro Digital',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
